import React from 'react'
import classNamesBind from 'classnames/bind'
import { CircumplexPointBreakdown } from '@dashboard/components/CircumplexGraph/types'

import css from './styles.module.scss'
const classNames = classNamesBind.bind(css)

interface OwnProps {
  pointBreakdown: CircumplexPointBreakdown
  textTypeToggled: boolean
  toggle: (value: boolean) => void
}

interface State {}

export default class PointSummary extends React.Component<OwnProps, State> {
  // Constructor
  constructor(props: OwnProps) {
    super(props)

    this.state = {}
  }

  render() {
    const { pointBreakdown } = this.props

    const discType = pointBreakdown.textType
    const expectedDiscType = pointBreakdown.expectedTextType

    const compatability = this._getCompatibility()

    return (
      <div className={classNames('container')}>
        <div className={classNames('header-text')}>
          {pointBreakdown.first_name}'s personality vs. coworker expectations
        </div>

        <div>
          <span className={classNames(discType)}>
            {pointBreakdown.first_name}’s
          </span>{' '}
          DISC type is{' '}
          <span className={classNames(discType)}>
            {pointBreakdown.textType}
          </span>
          , or
          <span className={classNames(discType)}>
            {' '}
            The {pointBreakdown.archetype}
          </span>
          . This is {compatability} your team’s average behavioral expectations
          for the role of {pointBreakdown.roleName}, which is
          <span className={classNames(expectedDiscType)}>
            {' '}
            {pointBreakdown.expectedTextType}
          </span>
          , or
          <span className={classNames(expectedDiscType)}>
            {' '}
            The {pointBreakdown.expectedArchetype}
          </span>
          .
        </div>
        <ul className={classNames('list')}>
          <li className={classNames('item')}>
            <b>{pointBreakdown.low}%</b> of the behaviors for this role are
            likely to come naturally to {pointBreakdown.first_name} and require
            very little energy.
          </li>
          <li className={classNames('item')}>
            <b>{pointBreakdown.medium}%</b> of the behaviors for this role are
            likely to require moderate adjustment from{' '}
            {pointBreakdown.first_name}, and require some energy.
          </li>
          <li className={classNames('item')}>
            <b>{pointBreakdown.high}%</b> of the behaviors for this role are
            likely to require significant adjustment from{' '}
            {pointBreakdown.first_name}, which may require a lot of energy.
          </li>
        </ul>
        {this.renderSummary()}
      </div>
    )
  }

  _getCompatibility() {
    const { pointBreakdown } = this.props

    if (pointBreakdown) {
      const distance = pointBreakdown.distance

      if (distance < 45) return 'very close to '
      else if (distance < 90) return 'fairly close to '
      else if (distance < 135) return 'fairly far from '
      else return 'very far from '
    }
  }

  renderSummary() {
    return (
      <div className={classNames('static')}>
        {this.renderToggle()}
        <div className={classNames('summary')}>{this.renderMap()}</div>
        <div className={classNames('summary')}>
          <div className={classNames('bubble', 'a')} />
          <div className={classNames('bubble', 'b')} />
          <div className={classNames('bubble', 'c')} />
          <div className={classNames('bubble', 'd')} />
          <div className={classNames('bubble', 'e')} />
          Unimportant/Important role behaviors
        </div>
      </div>
    )
  }

  renderToggle() {
    const { pointBreakdown, toggle, textTypeToggled } = this.props

    return (
      <div className={classNames('buttons')}>
        <div
          className={classNames('button', { active: !textTypeToggled })}
          onClick={() => toggle(false)}
        >
          {pointBreakdown.first_name}'s profile
        </div>
        <div
          className={classNames('button', { active: textTypeToggled })}
          onClick={() => toggle(true)}
        >
          Coworker expectations
        </div>
      </div>
    )
  }

  renderMap() {
    const { textTypeToggled, pointBreakdown } = this.props
    const discType = pointBreakdown.textType
    const expectedDiscType = pointBreakdown.expectedTextType

    if (textTypeToggled) {
      return (
        <div className={classNames('behaviors')}>
          <div className={classNames('natural', `${expectedDiscType}`)} />
          Behaviors that coworkers have selected as important
        </div>
      )
    } else {
      return (
        <div className={classNames('behaviors')}>
          <div className={classNames('natural', `${discType}`)} />
          Behaviors that come naturally to {pointBreakdown.first_name}
        </div>
      )
    }
  }
}
